<template>
    <BaseModal :title="$t('title')" white v-on="$listeners">
        <div class="l-stack l-gap-1">
            <i18n path="contactTel" tag="p">
                <template #link>
                    <a :href="'tel:' + tel" class="t-underline">{{ tel }}</a>
                </template>
            </i18n>

            <i18n path="contactTime" tag="p">
                <template #dayFrom>{{ dayFrom }}</template>
                <template #dayTo>{{ dayTo }}</template>
                <template #timespans>{{ timespans }}</template>
            </i18n>

            <i18n path="contactEmail" tag="p">
                <template #link>
                    <a :href="'mailto:' + email" class="t-underline">{{
                        email
                    }}</a>
                </template>
            </i18n>
        </div>

        <template v-if="hasFreshworksWidget" #footer>
            <div class="l-inline l-justify-end">
                <BaseButton size="small" @click="handleContact">
                    {{ $t('contactUs') }}
                </BaseButton>
            </div>
        </template>
    </BaseModal>
</template>

<script>
import BaseButton from './BaseButton'
import BaseModal from './BaseModal'

export default {
    name: 'SupportModal',
    components: {
        BaseButton,
        BaseModal,
    },
    data() {
        return {
            email: process.env.VUE_APP_SUPPORT_EMAIL,
            hasFreshworksWidget: !!process.env.VUE_APP_FRESHWORKS,
            tel: process.env.VUE_APP_SUPPORT_TEL,
        }
    },
    computed: {
        dayFrom() {
            return this.$t(
                `shared.weekdays.${process.env.VUE_APP_SUPPORT_DAY_FROM}`
            )
        },
        dayTo() {
            return this.$t(
                `shared.weekdays.${process.env.VUE_APP_SUPPORT_DAY_TO}`
            )
        },
        timespans() {
            return [
                process.env.VUE_APP_SUPPORT_TIMESPAN1,
                process.env.VUE_APP_SUPPORT_TIMESPAN2,
            ]
                .filter(Boolean)
                .map(timespan => this.$t('timespan', [timespan]))
                .join(this.$t('timespanConjunction'))
        },
    },
    beforeDestroy() {
        window.FreshworksWidget?.('close')
    },
    methods: {
        handleContact() {
            window.FreshworksWidget?.('open')
        },
    },
}
</script>

<i18n>
{
    "en": {
        "contactEmail": "Outside these hours, you can reach us by email at {link}.",
        "contactTel": "Phone: {link}",
        "contactTime": "{dayFrom} to {dayTo}, {timespans}.",
        "timespan": "{0}",
        "timespanConjunction": " and ",
        "title": "Support",
        "contactUs": "Contact us"
    },
    "de": {
        "contactEmail": "Ausserhalb dieser Zeiten sind wir per E-Mail erreichbar unter {link}.",
        "contactTel": "Telefon: {link}",
        "contactTime": "{dayFrom} bis {dayTo}, {timespans}.",
        "timespan": "{0} Uhr",
        "timespanConjunction": " sowie von ",
        "title": "Support",
        "contactUs": "Kontaktiere uns"
    },
    "fr": {
        "contactEmail": "En dehors de ces horaires, nous sommes joignables par e-mail à l'adresse {link}.",
        "contactTel": "Téléphone: {link}",
        "contactTime": "Du {dayFrom} au {dayTo}, {timespans}.",
        "timespan": "{0}",
        "timespanConjunction": " et ",
        "title": "Assistance",
        "contactUs": "Contactez-nous"
    },
    "it": {
        "contactEmail": "Al di fuori di questi orari, siamo raggiungibili via e-mail all'indirizzo {link}.",
        "contactTel": "Telefono: {link}",
        "contactTime": "Da {dayFrom} a {dayTo}, {timespans}.",
        "timespan": "{0}",
        "timespanConjunction": " e ",
        "title": "Supporto",
        "contactUs": "Contattaci"
    }
}
</i18n>
